module.exports = __webpack_public_path__ + "static/media/1_A1_04.d1f1da48.png";